import api from "../../index";

export const GetAllSymbolApi = (params) => api.get(`Admin/Get-Group-Detail?${params}`);
export const UpdateUserStatusApi = (data) => api.post("Admin/Update-Symbol-Detail", data);
export const GetAllSymbolDetailApi = (params) => api.get(`Admin/Get-Symbol-Detail?${params}`);

export const GetSymbolCrmGroupsApi = () => api.get("Admin/Symbol-Crm-Groups");
export const CreateSymbolCrmGroupApi = (data) => api.post("Admin/Symbol-Crm-Groups", data);
export const UpdateSymbolCrmGroupApi = (id, data) => api.put(`Admin/Symbol-Crm-Groups/${id}`, data);
export const DeleteSymbolCrmGroupApi = (id) => api.delete(`Admin/Symbol-Crm-Groups/${id}`);
export const GetSymbolCrmGroupSymbolsApi = (id) => api.get(`Admin/Symbol-Crm-Groups/${id}/Symbols`);
export const SetSymbolCrmGroupSymbolsApi = (id, data) =>
  api.put(`Admin/Symbol-Crm-Groups/${id}/Symbols`, data);
export const GetSymbolCrmAllSymbolsApi = (params) =>
  api.get(`Admin/Symbol-Crm-All-Symbols?${params}`);
export const SyncAllSymbolsApi = () => api.get("MT5Security/GetSymbolSync");
